import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

import Button from '@/src/shared/ui/button'
import {Image} from '@/src/shared/ui/image'
import {Link as UILink} from '@/src/shared/ui/link'

import {BurgerButton, MobileBurger} from './burger'

const buttonWidth = '162px'
const headerGap = '71px'

export const Header = styled.header`
  width: 100%;
  
  position: sticky;
  top: 0;
  z-index: 2005;
`

const HeaderLine = styled.div`
  font-size: 18px;

  padding: ${theme.token.layout.pagePadding}px;
  position: relative;

  width: 100%;
  background: ${theme.colors.bgDark};

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 20px;

  @media ${media.lg} {
    gap: ${headerGap};

    padding: ${theme.token.layout.pagePadding * 3}px 80px;
  }
`

export const HeaderTop = styled(HeaderLine)`
  z-index: 2005;
  height: ${theme.token.layout.headerHeight}px;

  position: sticky;
  top: 0;

  @media ${media.md} {
    height: unset;
  }

  @media ${media.lg} {
    padding: 44px 80px 0;
  }
`

export const Container = styled.div`
  z-index: 10;

  width: 100%;
  background: ${theme.colors.bgDark};

  display: flex;
  align-items: center;

  max-width: ${theme.sizes.container}px;

  gap: 20px;

  ${HeaderTop} & {
    z-index: 11;
    position: sticky;
    top: 0;
  }

  @media ${media.md} {
    gap: ${headerGap};
  }
`

export const TopContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${headerGap};

  @media ${media.md} {
    flex-direction: column;
    align-items: center;
  }

  @media ${media.lg} {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const ShopContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 50px;
  width: 100%;
`

export const HeaderBottom = styled(HeaderLine)`
  display: none;

  @media ${media.lg} {
    padding-top: 41px;
    padding-bottom: 45px;
    display: flex;
    flex-direction: row;
  }
`

export const ButtonWithIcon = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: ${buttonWidth};
  gap: 7px;

  span {
    font-weight: 450;
  }
`

export const SaleButton = styled(Button)`
  width: 100%;
  max-width: ${buttonWidth};
`

export const Links = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  color: ${theme.colors.gray6};

  @media ${media.lg} {
    flex: 1px;
  }
`

export const LinksContainer = styled.div`
  display: none;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 20px;
  justify-content: center;

  @media ${media.lg} {
    display: flex;
  }
`

export const Link = styled(UILink)`
  color: ${theme.colors.gray6};
  font-size: 18px;
  font-weight: normal;

  &:hover {
    color: ${theme.colors.primary};
  }
`

export const InfoButton = styled(ButtonWithIcon)`
  display: flex;

  @media ${media.lg} {
    display: none;
  }
`

export const ShopLocationsLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 11px;

  img {
    width: 15px;
  }
`

export const Icon = styled.span`
  position: relative;
  width: 17px;
  height: 15px;
  color: ${theme.colors.dark};
`

export const IconMenu = styled(Image)`
  position: absolute;
  left: 0;
  top: 0;
  width: 17px;
  height: 15px;

  opacity: 1;
  transition: 0.3s ease opacity;

  ${ButtonWithIcon}:hover & {
    opacity: 0;
  }
`
export const IconSearch = styled(Image)`
  position: absolute;
  bottom: 0;
  right: 0;

  width: 10px;
  height: 10px;
  transition: 0.3s ease transform;

  ${ButtonWithIcon}:hover & {
    transform: scale(1.6) translateX(-2px) translateY(-2px);
  }
`

export const NavWrapper = styled.div`
  width: 100%;
  display: none;
  gap: 17px;

  @media ${media.lg} {
    display: flex;
    align-items: center;
  }
`

export const NavBurgerButton = styled(BurgerButton)`
  display: flex;
  justify-content: center;
  white-space: nowrap;
  flex-wrap: nowrap;
  
  width: 100%;
  max-width: 162px;
  font-weight: 400;

  border-color: ${theme.colors.white}80;
  color: ${theme.colors.textDark};

  &:hover {
    border-color: ${theme.colors.primary};
    color: ${theme.colors.primary};
    background: transparent;
  }

  ${NavWrapper} & {
    display: none;

    @media ${media.md} {
      display: flex;
    }
  }
`

export const NavMenu = styled.div``
export const NavItems = styled.nav``

export const MobileButton = styled(MobileBurger)`
  @media ${media.lg} {
    display: none;
  }

  justify-content: center;

  border-color: ${theme.colors.white}80;
  color: ${theme.colors.textDark};

  &:hover {
    border-color: ${theme.colors.primary};
    color: ${theme.colors.primary};
    background: transparent;
  }
`

export const LogoWrapper = styled.div``

export const ShopLinks = styled.div`
  grid-area: shop;
  display: none;
  justify-content: space-evenly;
  align-items: center;
  gap: 19px;
  color: ${theme.colors.white};

  @media ${media.md} {
    display: flex;
  }
`

export const ContactsButtonMobile = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;

  @media ${media.md} {
    display: none;
  }
`

export const IconBtn = styled.button`
  color: ${theme.colors.white};
  display: flex;
`

export const IconLink = styled.a`
  color: ${theme.colors.white};
  display: flex;
`

export const ShopLink = styled.a`
  cursor: pointer;
  display: block;

  color: ${theme.colors.textDark};

  &:hover {
    ${ShopLinks} &,
    ${ShopLinks} & path {
      color: ${theme.colors.primary};
      stroke: ${theme.colors.primary};
    }
  }
`

export const SearchLink = styled(ShopLink)`
  display: flex;
  align-self: baseline;
`

export const ProfileLink = styled(ShopLink)``
export const WishLink = styled(ShopLink)`
  position: relative;
`
export const BasketLink = styled(ShopLink)`
  width: 24px;
  position: relative;
`

export const BasketCount = styled.span`
  position: absolute;
  right: -10px;
  top: 0;
  font-size: 14px;
  background: white;
  border-radius: 100%;
  color: black;
  padding: 2px;
  min-width: 20px;
  min-height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const FavouriteCount = styled.span`
  position: absolute;
  right: -10px;
  top: 0;
  font-size: 14px;
  background: white;
  border-radius: 100%;
  color: black;
  padding: 2px;
  min-width: 20px;
  min-height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const Popover = styled.div`
  .ant-popover-inner {
    max-height: calc(100vh - 150px);
  }
`